import { useQuery } from '@tanstack/react-query';
import { getGroupsByUserId } from './httpCalls';
import { enqueueSnackbar } from 'notistack';

export function useGetGroupsByUserId(userId) {
  return useQuery({
    queryFn: () => getGroupsByUserId(userId),
    queryKey: [`getGroupsByUserId`],
    onSuccess: () => {
      enqueueSnackbar('Επιτυχία!', {
        variant: 'success',
        autoHideDuration: 2000,
      });
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.message || 'Κάτι πήγε στραβά', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    },
  });
}
